// extracted by mini-css-extract-plugin
export default {"pagingContainer":"Pagination_pagingContainer__7FB7h","pagingButton":"Pagination_pagingButton__I3zp7","pageAndTotalResultsContainer":"Pagination_pageAndTotalResultsContainer__XSDIl"};